import { i18n } from '@/locales';
const lc = 'views.hub_management.';
const sortByCodeOptionList = [
    'DISTANCE',
    'TIME',
    'USER_CHOICE', // default
    'PICKUP_EXPECTED_AT',
    'OWN_ORDER',
];
export default sortByCodeOptionList.map((code, index) => ({
    text: i18n.t(`${lc}hub_configuration.sort_by_code_type_list[${index}]`),
    value: code,
}));
